import { jsx } from "panel";
import { LineChartEl } from "common/charts/visualization/line-chart";
import { SegmentLegendHeaderEl } from "common/charts/misc/segment-legend-header";
import { ContextMenuEl } from "common/widgets/context-menu";
export function template() {
  if (!this.state.segmentData) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".root"
    });
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, /* @__PURE__ */ jsx(SegmentLegendHeaderEl, {
    sel: ".segment-header"
  }), /* @__PURE__ */ jsx(LineChartEl, {
    sel: ".line-chart",
    attrs: this.helpers.getLineChartAttrs(),
    props: this.helpers.getLineChartProps()
  }), this.state.popoverSelection && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ContextMenuEl, {
    attrs: {
      "menu-items": this.popoverCallback(this.state.popoverSelection.series.options.name),
      "relative-positioning": true,
      open: true,
      position: { left: 0, top: 0 }
    },
    style: this.state.popoverStyles,
    on: {
      action: (ev) => this.handlePopoverAction(ev),
      close: () => this.handlePopoverClose()
    }
  })));
}
